import { FileRecordStatus } from "../../../../../common/types/FileRecordStatus";

export const applicableFileRecordLookupStatuses = [
    FileRecordStatus.Created,
    FileRecordStatus.Qc,
    FileRecordStatus.Editing,
    FileRecordStatus.WaitingForClientResponse,
    FileRecordStatus.QcDone
];
